/**
 * MatryxCommit.js
 * Class for parsing values from MatryxCommit smart contract
 *
 * Authors dev@nanome.ai
 * Copyright (c) 2018, Nanome Inc
 * Licensed under ISC. See LICENSE.md in project root.
 */

import { fromWei, toWei, solidityKeccak, stringToBytes32 } from ".."
import Contract from "./Contract"

export default class MatryxCommit extends Contract {
  async getCommit(commitHash) {
    let commit = await this.contract.getCommit(commitHash)

    commit.height = +commit.height
    if (!commit.height) return null

    commit.value = fromWei(commit.value)
    commit.totalValue = fromWei(commit.totalValue)
    commit.ownerTotalValue = fromWei(commit.ownerTotalValue)

    commit.timestamp = +commit.timestamp
    commit.date = new Date(1000 * commit.timestamp)

    return commit
  }

  async getCommitByContent(content) {
    let commit = await this.contract.getCommitByContent(content)

    commit.height = +commit.height
    if (!commit.height) return null

    commit.value = fromWei(commit.value)
    commit.totalValue = fromWei(commit.totalValue)
    commit.ownerTotalValue = fromWei(commit.ownerTotalValue)

    commit.timestamp = +commit.timestamp
    commit.date = new Date(1000 * commit.timestamp)

    return commit
  }

  async getInitialCommits() {
    return await this.contract.getInitialCommits()
  }

  async getGroupMembers(commitHash) {
    return await this.contract.getGroupMembers(commitHash)
  }

  async getSubmissionsForCommit(commitHash) {
    return await this.contract.getSubmissionsForCommit(commitHash)
  }

  async getAvailableRewardForUser(commitHash, user) {
    let reward = await this.contract.getAvailableRewardForUser(commitHash, user)
    return fromWei(reward)
  }

  // TRANSACTION FUNCTIONS BELOW

  async addGroupMember(commitHash, userAddress) {
    return await this.contract.addGroupMember(commitHash, userAddress)
  }

  async addGroupMembers(commitHash, userAddresses) {
    return await this.contract.addGroupMember(commitHash, userAddresses)
  }

  async claimCommit(sender, salt, content) {
    salt = stringToBytes32(salt)

    let commitHash = solidityKeccak(["address", "bytes32", "string"], [sender, salt, content])

    return await this.contract.claimCommit(commitHash)
  }

  async createCommit(parentHash, isFork, salt, content, value) {
    salt = stringToBytes32(salt)
    value = toWei(value)
    parentHash = parentHash || "0x".padEnd(66, "0")

    return await this.contract.createCommit(parentHash, isFork, salt, content, value)
  }

  async createSubmission(tournament, content, parentHash, isFork, salt, commitContent, value) {
    salt = stringToBytes32(salt)
    value = toWei(value)
    parentHash = parentHash || "0x".padEnd(66, "0")

    return await this.contract.createSubmission(
      tournament,
      content,
      parentHash,
      isFork,
      salt,
      commitContent,
      value
    )
  }

  async withdrawAvailableReward(hash) {
    return await this.contract.withdrawAvailableReward(hash)
  }
}
